var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneLoginShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 42,
    viewBox: "0 0 24 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29102 14.3069H9.87324V37.6328C9.87324 39.842 11.6641 41.6328 13.8732 41.6328H19.811C22.0202 41.6328 23.811 39.842 23.811 37.6328V4.12695C23.811 1.91781 22.0202 0.126953 19.811 0.126953H4.29102C2.08188 0.126953 0.291016 1.91782 0.291016 4.12696V10.3069C0.291016 12.516 2.08188 14.3069 4.29102 14.3069Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLoginShort);
export default __webpack_public_path__ + "static/media/oneLoginShort.b22fe6362138c5b16f35518a64e4be7a.svg";
export { ForwardRef as ReactComponent };